/**
 * @generated SignedSource<<b9ef0f8594c1a06ffc15c1372cf7ca1f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "VibePost",
    "kind": "LinkedField",
    "name": "incrementView",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "viewsCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "viewedByCurrentUser",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "viewCounterIncrementViewMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "viewCounterIncrementViewMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6676942acae3199564fcd014c7a99a6a",
    "id": null,
    "metadata": {},
    "name": "viewCounterIncrementViewMutation",
    "operationKind": "mutation",
    "text": "mutation viewCounterIncrementViewMutation(\n  $request: IncrementViewRequestInput!\n) {\n  incrementView(request: $request) {\n    id\n    viewsCount\n    viewedByCurrentUser\n  }\n}\n"
  }
};
})();

node.hash = "65890a8963d8a794a731b0ca94679bc2";

module.exports = node;
